import { useMemo } from 'react';
import { SettingsStore, ConfigStore, ZenJsUtils } from '@zen/common-app-parts';

/**
 * Get the Oracle contract id and address
 * @returns {{id: string, address: string}}
 */
export default function useContract() {
  const {
    state: {
      settings: { chain },
    },
  } = SettingsStore.useStore();
  const { contract } = ConfigStore.useStore();
  const id = contract[chain];
  const address = useMemo(() => ZenJsUtils.getContractAddress(chain, id), [chain, id]);

  return { id, address };
}
